/** CSS module class keys for atmospheric header gradients keyed by weather condition. */
export type WeatherHeroVariant =
  | 'heroClear'
  | 'heroCloudy'
  | 'heroRain'
  | 'heroSnow'
  | 'heroStorm'
  | 'heroFog'
  | 'heroDefault';

export function weatherHeroVariant(condition: string, iconName?: string): WeatherHeroVariant {
  const lower = condition.toLowerCase();
  const icon = iconName ?? '';

  if (lower.includes('thunder') || icon.includes('bolt')) {
    return 'heroStorm';
  }
  if (lower.includes('snow') || icon.includes('snow')) {
    return 'heroSnow';
  }
  if (
    lower.includes('rain') ||
    lower.includes('shower') ||
    lower.includes('drizzle') ||
    icon.includes('rain') ||
    icon.includes('drizzle')
  ) {
    return 'heroRain';
  }
  if (lower.includes('fog') || icon.includes('fog')) {
    return 'heroFog';
  }
  if (lower.includes('clear') || icon.includes('sun.max')) {
    return 'heroClear';
  }
  if (lower.includes('cloud') || icon.includes('cloud')) {
    return 'heroCloudy';
  }
  return 'heroDefault';
}
